import { render, staticRenderFns } from "./grossing-touch-text-templates-sidepanel.vue?vue&type=template&id=eeeb3e62&scoped=true&"
import script from "./grossing-touch-text-templates-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-text-templates-sidepanel.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-text-templates-sidepanel.scss?vue&type=style&index=0&id=eeeb3e62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeeb3e62",
  null
  
)

export default component.exports